import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from 'src/lib/utils';

const alertVariants = cva('relative w-full flex gap-3.5 rounded-xl border p-4 text-sm [&>svg]:shrink-0 [&>svg]:mt-0.5', {
  variants: {
    variant: {
      default: 'bg-background text-foreground border-border',
      destructive: 'bg-danger-bg border-danger/30 text-danger [&>svg]:text-danger',
      success: 'bg-success-bg border-success/30 text-success [&>svg]:text-success',
      warning: 'bg-warning-bg border-warning/30 text-warning [&>svg]:text-warning',
      info: 'bg-info-bg border-info/30 text-info [&>svg]:text-info',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const Alert = React.forwardRef(function Alert({ className, variant, ...props }, ref) {
  return <div ref={ref} role='alert' className={cn(alertVariants({ variant }), className)} {...props} />;
});

const AlertTitle = React.forwardRef(function AlertTitle({ className, ...props }, ref) {
  return <h5 ref={ref} className={cn('font-semibold leading-none tracking-tight', className)} {...props} />;
});

const AlertDescription = React.forwardRef(function AlertDescription({ className, ...props }, ref) {
  return <div ref={ref} className={cn('text-sm [&_p]:leading-relaxed', className)} {...props} />;
});

export { Alert, AlertTitle, AlertDescription, alertVariants };
